import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { updateCustomerAddress } from '../customers'

export default function useCustomerAddressUpdate() {
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(updateCustomerAddress, {
    onSuccess: () => {
      queryClient.invalidateQueries(`customerAddresses`)
      notification.success({
        message: 'Sucesso!',
        description: 'Atualização realizada com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível atualizar!'
      })
    }
  })

  return { mutate, isLoading }
}
